// RETAIL DRAG & DROP CODE
<!-- DRAG & DROP EXPLINATION BUTTON  -->
<template>
    <v-container class="pa-0 ma-0" id="mainhomecontainer">
        <v-card class="overview" elevation="0">
            <v-overlay v-model="overlay"
                :color= "storeBusiness.themecolor!=NULL?storeBusiness.themecolor:'#FE5800'" >
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>
<!-- DRAG & DROP EXPLINATION BUTTON  -->
            <v-row class="d-none d-md-flex " justify="right">
                    <v-col cols="12" class="text-left">
                        <!-- <v-btn color="primary" class="ml-3 " -->
                        <v-row>
                            <div class="pl-11">
                                <v-dialog v-model="dialog" width="800">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                        elevation="2"
                                        color="#FE5800"
                                        fab
                                        small
                                        v-bind="attrs"
                                        v-on="on"
                                        >
                                            <v-icon color="white">mdi-information-variant</v-icon>
                                        </v-btn>
                                    </template>
                                    <v-card>
                                        <v-card-title class="text-h1 zzorganebg">
                                            <h1 class="font-weight-bold display-2 text--pr"><v-icon style="font-size:50px;color:white" class="pr-2">mdi-drag-variant</v-icon>{{$t('zz_drag_and_drop_title')}}</h1>
                                        </v-card-title>
                                        <p class="pt-5 px-4">
                                            <span v-html="$t('zz_drag_and_drop_explination')">
                                            </span>
                                        </p><br>
                                        <v-divider></v-divider>
                                        <p class="pt-5 px-4"><span v-html="$t('zz_remember_to_save')"></span></p><br>
                                    </v-card>
                                </v-dialog>
                            </div>
<!-- ADD NEW ITEM BUTTON                              -->
                            <v-btn elevation="2" color="#FE5800" class="ml-3" @click="$router.push({name:'createretailitem'})">
                                {{$t('zz_add_new')}}<v-icon class="pl-2">mdi-plus-circle-outline</v-icon>
                            </v-btn>
                            <v-btn elevation="10" color="#FE5800" class="bounce ml-3" v-if="isdragged" @click="savemenu" >
                                {{$t('zz_save_food_menu_changes')}}
                            </v-btn>
                            <span class="ml-3 success--text font-weight-bold" v-if="savemsg!=''">
                                {{savemsg}}
                            </span>
                        </v-row>
                    </v-col>
                </v-row>
<!-- END OF DRAG & DROP EXPLINATION BUTTON                  -->


            <v-card-text  class="d-none d-md-flex" style="width:100%; overflow-x:scroll; height:1500px;">
                <div  class="overflowcol" style="height:2000px;">
                    <draggable v-model="retailitems.category" @start="drag=1" @end="dragretailitem('c')" >
                        <transition-group>
                            <div class="maxtall course_col" :class="drag?move:''" v-for="category in retailitems.category" :key="'c-'+category.id" title>
                                <v-card elevation="24" class="mb-5 maxtall dnd-card-height course-heading-card">
                                    <v-card-text class="white--text aligncenter ma-0 pa-0 py-2">
                                        <p class="courseheading ma-0 pa-0">
                                            {{category.name}}
                                        </p>
                                        <template>
                                            <v-row style="top:4px; right:4px; position:absolute; z-index=9999" class="align-end pl-0 pr-0">
                                                <v-menu transition="fab-transition">
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-btn @click.stop float-right color="#FE5800" icon v-bind="attrs" v-on="on">
                                                        <!-- <v-icon style="top:0px; right:0px; position:absolute; z-index=9999" class="compact-cogs-75 white-cog">fa fa-cogs</v-icon> -->
                                                        <v-icon class="cog-position-1 compact-cogs-75 white-cog">fa fa-cogs</v-icon>
                                                    </v-btn>
                                                </template>
                                                <v-list dense no-gutters ma-0 pa-0 class="px-5 pt-1">
                                                    <v-icon color="red" icon dark class="close-menu-left pa-0 ma-0 pt-2 pl-3">
                                                        mdi-close-circle
                                                    </v-icon>
                                                    <v-list-item>
                                                        <span class="edit-item-name">{{category.name}}</span>
                                                    </v-list-item>
                                                    <v-list-item>
                                                    <div cols="12">
                                                        <v-switch class="pl-1 compact-toggle-dnd-1" inset color="success" :input-value="shw"  @click=""></v-switch>
                                                    </div>
                                                    </v-list-item>
                                                    <v-list-item>
                                                        <v-btn icon @click="" color="#FE5800 " fab x-small dark
                                                            class="mt-2 mb-2">
                                                            <v-icon>mdi-square-edit-outline</v-icon>
                                                        </v-btn>
                                                    </v-list-item>
                                                </v-list>
                                                </v-menu>
                                            </v-row>
                                        </template>
                                    </v-card-text>
                                </v-card>
                                <div class="mt-12"></div>
                                <v-card-content>
                                    <draggable @start="dragitem=1;" @end="dragretailitem('i');" v-model="category.retailitem">
                                        <transition-group>
                                            <v-card elevation="24" class="mb-3 maxtall" :class="item.separation==1?'seperatorretaildnd':''" v-for="(item,index) in category.retailitem" :key="'fd-'+item.id" >

                                                <v-col clos="12" md="12" no-gutters class="ma-0 pa-0">
                                                    <v-row no-gutters class="ma-0 pa-0 section-spread">
<!-- IMAGE   -->                                        <v-col no-gutters class="ma-0 pa-0" cols="4" md="4" v-if="item.separation==0">
                                                            <container jusitfy:start>
                                                                <v-img height="100" class="text-left dnd-drink-image-max  pl-0 pt-0 pb-0 pr-0" v-if="item.separation==0" :class="item.showonmenu==0? 'inactiveimg':'' "
                                                                    :src="item.fimage"/>
                                                                </v-img>
                                                            </container>
                                                        </v-col>


                                                        <v-col v-if="item.showonmenu==1" :cols="item.separation>0?9:6" class="pt-2 pb-2 pl-5" cols="6" md="6">
                                                            <v-row class="retail-title-dnd" :class="item.separation==1?'white-text-heading':''">
                                                                <v-card-text class="text-left ma-0 pa-0 text-truncate">
                                                                    {{item.retailitemname}}
                                                                </v-card-text>
                                                            </v-row>
                                                            <v-row class="retail-subtitle-dnd" v-if="item.separation==0">
                                                                <v-card-text class="text-left ma-0 pa-0 text-truncate">
                                                                    {{item.subtitle}}
                                                                </v-card-text>
                                                            </v-row>
                                                            <v-row class="text-right" v-if="item.separation==0">
                                                                <span class="retail-price-dnd">
                                                                    {{parseFloat(item.price).toFixed(2)}}
                                                                </span>
                                                            </v-row>
                                                        </v-col>

<!-- GREY OUT INACTIVE ITEM TEXT  -->                   <v-col v-else cols="6" md="6" class="pt-2 pb-2 pl-5">
                                                            <v-row class="retail-title-dnd-hidden">
                                                                <v-card-text class="text-left ma-0 pa-0 text-truncate">
                                                                    {{item.retailitemname}}
                                                                </v-card-text>
                                                            </v-row>
                                                            <v-row class="retail-subtitle-dnd-hidden" v-if="item.separation==0">
                                                                <v-card-text class="text-left ma-0 pa-0 text-truncate">
                                                                    {{item.subtitle}}
                                                                </v-card-text>
                                                            </v-row>
                                                            <v-row class="text-right">
                                                                <span class="retail-price-dnd-hidden" v-if="item.separation==0">
                                                                    {{parseFloat(item.price).toFixed(2)}}
                                                                </span>
                                                            </v-row>
                                                        </v-col>


<!-- Gogs and Edit Menu  -->                                <v-col no-gutters cols="2" md="2" class="alignrigth pr-0">
                                                            <v-menu no-gutters ma-0 pa-0 bottom right transition="fab-transition">
                                                                <template v-slot:activator="{ on, attrs }" class="pa-0 ma-0">
                                                                    <v-btn class="pa-0 ma-0" color="#FE5800" icon v-bind="attrs" v-on="on">
                                                                        <v-icon no-gutters class="ma-0 pa-0 compact-toggle-dnd-1" :class="item.showonmenu==0? 'inactivecogsimg' :''">fa fa-cogs</v-icon>
                                                                    </v-btn>
                                                                </template>
                                                                <v-list dense no-gutters ma-0 pa-0 class="px-5 pt-1">
                                                                    <v-icon color="red" icon dark class="close-menu-left pa-0 ma-0 pt-2 pl-2">
                                                                        mdi-close-circle
                                                                    </v-icon>
                                                                    <!-- <v-list dense no-gutters ma-0 pa-0 class="px-5 pt-1"> -->
                                                                    <v-list-item>
                                                                        <span class="mt-4 edit-item-name">{{item.retailitemname}}</span>
                                                                    </v-list-item>
                                                                    <div  v-if="item.showonmenu==1 " >
                                                                        <v-switch class="pl-1 compact-form" inset  color="success" :input-value="shw"  @click="updateshowitem(item.id,0)" :id="'showonitem-'+item.id"></v-switch>
                                                                    </div>
                                                                    <div v-else>
                                                                        <v-switch class="pl-1 compact-form" inset  color="red" :input-value="nshw"  @click="updateshowitem(item.id,1)" :id="'showonitem-'+item.id"></v-switch>
                                                                    </div>
                                                                    <v-list-item v-if="item.separation==0">
                                                                        <v-btn icon @click.prevent="retailitemimage(item.id,item.showonmenu)" color="#FE5800 " fab x-small dark class="mt-2 mb-2">
                                                                            <v-icon>mdi-camera-plus-outline</v-icon>
                                                                        </v-btn>
                                                                    </v-list-item>
                                                                    <v-list-item>
                                                                        <v-btn icon @click="editItem(item.id)" color="#FE5800 " fab x-small dark
                                                                            class="mt-2 mb-2">
                                                                            <v-icon>mdi-square-edit-outline</v-icon>
                                                                        </v-btn>
                                                                    </v-list-item>
                                                                    <v-list-item>
                                                                        <v-btn icon @click="deleteItem(item.id)" color="#FE5800 " fab x-small dark class="">
                                                                            <v-icon>mdi-trash-can-outline</v-icon>
                                                                        </v-btn>
                                                                    </v-list-item>
                                                                </v-list>
                                                            </v-menu>
                                                        </v-col>
                                                    </v-row>
                                                </v-col>
                                            </v-card>
                                        </transition-group>
                                    </draggable>
                                </v-card-content>
                            </div>
                        </transition-group>
                    </draggable>
                </div>
            </v-card-text>
        </v-card>

        <v-dialog v-model="itemimagedialog" content-class="itemdetaildialog" scrollable fullscreen hide-overlay transition="dialog-bottom-transition">
            <v-card tile class="" elevation="3" color="#fff"   >
                <v-card-text class="pa-0 carddetail" elevation="3" color="#fff">

                    <v-form v-model="valid" enctype="multipart/form-data" id="editretailitem">

                        <v-row>
                            <v-col cols="9" md="9" class="font-weight-bold pb-0" style="font-size:18px;" >
                            Show On Menu
                            </v-col>
                            <v-col cols="3" md="3" class="pb-0">
                                <div v-if="retailitemshowonmenu==1 ">
                                    <v-switch  color="success" :input-value="shw" @click="updateshowitem(itemupdateid,0)"   :id="'showonitem-'+itemupdateid"></v-switch>
                                </div>
                                <div v-else>
                                    <v-switch  color="" :input-value="nshw" @click="updateshowitem(itemupdateid,1)"  :id="'showonitem-'+itemupdateid"></v-switch>

                                </div>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="12" md="12" class="text-center"><h4>Update Image</h4></v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="12" md="12" sm="12">

                            <v-row v-if="mainimguploading">
                                <v-col cols="12" class="text-center">
                                    <v-progress-circular
                                    indeterminate
                                    color="primary"
                                    ></v-progress-circular>
                                </v-col>
                            </v-row>

                            <Cropper v-show="uploadedimage!=null && uploadedimage!='null' " class="cropper" :src="uploadedimage" @change="onChange" :stencilProps="{aspectRatio: 16/9}"/>

                            <v-row>
                                <v-col cols="12" md="12" sm="12" class="text-center mb-5 mt-3" >

                                <v-img class="backimg"  :src="addphoto" @click="$refs.file.click()" style="max-height:200px;background-size: contain;">
                                    <input
                                    type="file"
                                    ref="file"
                                    @change="uploadImage($event)"
                                    accept="image/*"
                                    class=""
                                    id="itemimage"
                                    />
                                </v-img>
                                </v-col>

                                <v-col cols="12" md="12" sm="12" class="text-center mb-9">
                                    <v-btn color="primary" block large @click.stop="updateimage">Update</v-btn>

                                </v-col>

                            </v-row>

                            </v-col>
                        </v-row>

                    </v-form>


                </v-card-text>

            </v-card>

            <v-footer
            absolute
            class="font-weight-medium "
            color="transparent">
                <v-col
                    class="text-center"
                    cols="12">
                    <v-btn @click="backtomenuimage" fab small color="#fe5800" >
                        <v-icon class="white--text ">mdi-close</v-icon>
                    </v-btn>
                </v-col>
            </v-footer>
        </v-dialog>
    </v-container>
</template>

<script>
    import Vue from 'vue'
    import draggable from 'vuedraggable'
    import { Cropper } from 'vue-advanced-cropper'
    export default
    {
        props: {
        source: String
        },
        data: () => ({
            itemimagedialog:false,
            mainimguploading:false,
            uploadedimage:null,
            addphoto: require("@/assets/addphoto.svg"),

            shw:true,
            nshw:false,
            switchValue:false,
            showonitem:true,
            overlay: false,
            drag:0,
            savemsg:'',
            isdragged:0,
            dragitem:0,
            id:'',
            retailitems:{
                categories:[]
            },
            itemupdateid:0,
            fooditemshowonmenu:0,
            retailitemshowonmenu:0,
            valid:true,

        }),
        components:
        {
            draggable,
             Cropper,
        },

        created()
        {
            this.storeBusiness=JSON.parse(localStorage.getItem('business'));

            this.id=this.storeBusiness.id;

            this.overlay=true;


            this.$http
            .get(this.$apidomain+"retailitemlistcategory/"+this.id)
            .then(res => {
                if(res.data.success==0)
                {
                    //this.$router.push({name:'businesslistnew'});
                }
                this.retailitems = res.data.items;
                this.overlay=false;


            })
            .catch(err => {
                console.log(err.response);
                this.overlay=false;

            });

        },

        methods:
        {
            backtomenuimage()
            {
                this.itemimagedialog=false;
                this.overlayfooditem=false;

            },

            onChange({coordinates, canvas})
            {

                this.coordinates = coordinates
                // You able to do different manipulations at a canvas
                // but there we just get a cropped image
                this.image = canvas.toDataURL()
                this.mainimguploading=false;

            },

            uploadImage(event)
            {
                // Reference to the DOM input element
                var input = event.target;
                // Ensure that you have a file before attempting to read it
                if (input.files && input.files[0]) {
                        this.mainimguploading=true;

                        // create a new FileReader to read this image and convert to base64 format
                        var reader = new FileReader();
                        // Define a callback function to run, when FileReader finishes its job
                        reader.onload = (e) => {
                                // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
                                // Read image as base64 and set to imageData
                                this.uploadedimage = e.target.result;
                        }
                        // Start the reader job - read file as a data url (base64 format)
                        reader.readAsDataURL(input.files[0]);
                }
            },

            updateimage()
            {
                let fd = new FormData(document.getElementById("editretailitem"));

                if(this.uploadedimage!=null){
                    fd.append('imagea',this.dataURLtoFile(this.image,document.getElementById('itemimage').files[0].name));
                }

                this.overlayfooditemimageupdate=true;

                this.$http
                .post(this.$apidomain+"updateretailItemImage/"+this.itemupdateid, fd)
                .then(res => {
                    if(res.data.success==1)
                    {

                        this.itemimagedialog=false;
                        this.overlayfooditemimageupdate=false;


                        // this.$router.push({name:'food',params:{tag:this.business.id,key:''}});
                        // this.$router.push({name:'businessfoodlist'});
                        this.$router.go('/');

                    }
                    else
                    {
                        this.overlay=false;
                        this.itemimagedialog=false;

                        let errmsg=[];
                        for(var prop in res.data.errors){
                            errmsg.push(res.data.errors[prop][0]);
                        }
                        alert(errmsg[0]);
                    }
                })
                .catch(err => {
                        this.overlay=false;

                        console.log(err.response);
                });

            },
            dataURLtoFile(dataurl, filename)
            {

                    var arr = dataurl.split(','),
                        mime = arr[0].match(/:(.*?);/)[1],
                        bstr = atob(arr[1]),
                        n = bstr.length,
                        u8arr = new Uint8Array(n);

                    while(n--){
                        u8arr[n] = bstr.charCodeAt(n);
                    }

                    return new File([u8arr], filename, {type:mime});
            },
            retailitemimage(fiid,showonmenu)
            {

                this.itemimagedialog=true;
                this.itemupdateid=fiid;
                this.fooditemshowonmenu=showonmenu;
                this.retailitemshowonmenu=showonmenu;

            },
            dragretailitem(dtype)
            {
                this.isdragged=1;
                this.savemsg='';
                if(dtype=='c')
                {
                    this.drag=0;
                }

                if(dtype=='i')
                {
                    this.dragitem=0;
                }

            } ,
            editItem(item){
                this.$router.push({name:'editretailitem',params:{id:item}});
            },
            deleteItem(item)
            {
                if (confirm("Are you sure you want to delete this Retail Item?"))
                {
                    this.$http
                    .post(this.$apidomain+"deleteretailItem/"+item)
                    .then(res => {

                        this.$http
                        .get(this.$apidomain+"retailitemlistcategory/"+this.id)
                        .then(res => {
                            if(res.data.success==0)
                            {
                                //this.$router.push({name:'businesslistnew'});
                            }
                            this.retailitems = res.data.items;
                            this.overlay=false;


                        })
                        .catch(err => {
                            console.log(err.response);
                            this.overlay=false;

                        });

                    })
                        .catch(err => {
                                console.log(err.response);
                        });
                }
            },

            savemenu()
            {
                this.overlay=true;

                this.$http
                    .post(this.$apidomain+"saveretailitemorder",{data:JSON.stringify(this.retailitems),businessid:this.id})
                    .then(res => {
                        if(res.data.success==1)
                        {
                                this.isdragged=0;
                                this.savemsg=res.data.msg;
                                this.items = res.data.items;
                                this.$http
                                .get(this.$apidomain+"retailitemlistcategory/"+this.id)
                                .then(res => {
                                    if(res.data.success==0)
                                    {
                                        //this.$router.push({name:'businesslistnew'});
                                    }
                                    this.retailitems = res.data.items;
                                    this.overlay=false;


                                })
                                .catch(err => {
                                    console.log(err.response);
                                    this.overlay=false;

                                });
                        }
                        // this.fooditems = res.data.fooditems
                        // this.overlay=false;


                    })
                    .catch(err => {
                        console.log(err.response);
                        this.overlay=false;

                    });
            }  ,


        updateshowitem(item,showitem)
        {
            this.overlay=true;

            //  let showitem=showitem;
            //showitem= document.getElementById('showonitem-'+itemid).value;

            // console.log('show item value ' + showitem+' itemid '+itemid);

            this.$http
            .post(this.$apidomain+"updateretailitemshow/"+item,{showitem:showitem})
            .then(res => {
                if(res.data.success==1)
                {

                         this.overlay=true;

                           this.$http
                        .get(this.$apidomain+"retailitemlistcategory/"+this.id)
                        .then(res => {
                            if(res.data.success==0)
                            {
                                //this.$router.push({name:'businesslistnew'});
                            }
                            this.retailitems = res.data.items;
                            this.overlay=false;


                        })
                        .catch(err => {
                            console.log(err.response);
                            this.overlay=false;

                        });
                }



            })
            .catch(err => {
                console.log(err.response);
                this.overlay=false;

            });

        },
        },
    }

</script>

<style>
    .course_col
    {
        width:360px;
        float:left;
        padding: 15px;
    }
    .cardlist{

        border-top-right-radius: 40px !important;
        border-bottom-left-radius: 40px !important;
    }
    .move
    {
        cursor: nesw-resize;
    }
    .course-heading-card{

    border-radius: 0px !important;
    padding-left: 5px;
    padding-right: 5px;
    padding-bottom: 5px;
    background-color:#FE5800 !important;
    color: white !important;
}



.cardlistretail{

    border-radius: 5px !important;
    padding-left: 5px;
    padding-right: 5px;
    padding-bottom: 50px;
    background-color: rgb(234, 103, 103);
}


.cardlistnone{
    max-width: 100px !important;
    max-height: 75px !important;
    border-radius:none;
    border:none !important;
    box-shadow: none !important;

}

.cardlist{

        max-width: 960px;
        /*max-height: 150px;*/
        border-top-right-radius: 0px !important;
        border-bottom-left-radius: 0px !important;
    }

 .cardlistheading{
    max-width: 400px;
    /* border-radius:none; */
    border:none !important;
    box-shadow: none !important;
    background-color: crimson !important;

    }

.retail-title-dnd
    {
        font-size:16px !important;
        font-weight:800 !important;
        color: rgb(26, 26, 26) !important;
        text-transform:uppercase !important;
        padding-top: 1px !important;
        padding-bottom: 0px !important;
        line-height: 1;
    }

.retail-subtitle-dnd{
        padding-top: 1px !important;
        padding-bottom: 0px !important;
        color: rgb(26, 26, 26) !important;
        font-size:14px !important;
		font-weight: 500 !important;
        line-height: 1;
        text-transform:capitalize !important;
        text-align: justify !important;
        /* line-height: 14px !important; */
        padding-left: 0px !important;

    }

.retail-strapline-dnd{
    padding-top: 1px;
    padding-bottom: 0px;
    color: rgb(26, 26, 26);
    font-size:12px;
    font-weight: 300;
    text-transform:capitalize;
    text-align: justify;
    /* font-style: italic; */
    /* line-height: 12px; */
    padding-left: 0px !important;

}

.retail-price-dnd {
    padding-top: 0px;
    padding-bottom: 10px;
    color: rgb(29, 28, 28) !important;
    font-size:10px;
    font-weight: 400;

}

.retail-title-dnd-hidden {
        font-size:16px !important;
        font-weight:500 !important;
        color: rgb(158, 158, 158) !important;
        text-transform:uppercase !important;
        padding-top: 1px !important;
        padding-bottom: 0px !important;
        line-height: 1;
    }

.retail-subtitle-dnd-hidden {
        padding-top: 1px !important;
        padding-bottom: 0px !important;
        color: rgb(221, 221, 221) !important;
        font-size:14px !important;
		font-weight: 500 !important;
        line-height: 1;
        text-transform:capitalize !important;
        text-align: justify !important;
        /* line-height: 14px !important; */
        padding-left: 0px !important;

    }

.retail-strapline-dnd-hidden {
    padding-top: 1px;
    padding-bottom: 0px;
    color: rgb(221, 221, 221) !important;
    font-size:12px;
    font-weight: 300;
    text-transform:capitalize;
    text-align: justify;
    /* font-style: italic; */
    /* line-height: 12px; */
    padding-left: 0px !important;

}

.retail-price-dnd-hidden {
    padding-top: 0px;
    padding-bottom: 10px;
    color: rgb(152, 152, 152) !important;
    font-size:10px;
    font-weight: 200;

}

.maxtall{
    max-height: 100px;
}

.price-row{
  padding-top: 0px;
  padding-bottom: 0px;
  padding-left: 40px;
  padding-right: 30px;


}

.toggle-r{
  padding-right: 50px;
}
.overflowcol{

    flex-shrink: 0;

}

.maxheightimg{
    max-height: 100px;
}

.aligntotheright{
  justify-content: flex-end;
}
.course_col {
    width: 360px;
    float: left;
    padding: 15px;
    border-top-right-radius: 0px !important;
    border-bottom-left-radius: 0px !important;
}

.alignrigth{

    text-align: right;

}

.iconcolor{
    color: green !important;

}

.hiddenitem{
    columns: red;
}

.seperatorretaildnd{
    background-color: rgb(129, 129, 129) !important;
    border-radius: 0px;
}

.compact-form {
    transform: scale(0.75);
    transform-origin: right;
}

/* @-webkit-keyframes bounce {
        0% {
    transform: scale(1,1) translate(0px, 0px);
  }

  30%{
    transform: scale(1,0.8) translate(0px, 15px);
  }

  75%{
    transform: scale(1,1.1) translate(0px, 1px);
  }

 100% {
    transform: scale(1,1) translate(0px, 0px);
  }
}

.bounce {
      text-align:center;
      margin:0 auto;

     -webkit-animation: bounce 0.75s infinite;
} */


 .close-menu-right{
    position: fixed;
    right: 0px;
    top: 0px;
    }

    .close-menu-left{
    position: fixed;
    left: 0px;
    top: 0px;
    }
.section-spread{
    justify-content: space-between;
}
.inactiveimg{
    opacity: .25;
    border-bottom-left-radius: 3px;
    border-top-left-radius: 3px;
}

.inactivecogsimg{
    color: rgb(158, 158, 158) !important;
    /* opacity: .75; */
    /* color: rgb(176, 176, 176) !important; */
}

.inactiveimg{
    opacity: .25;
}

.retailimg{
    border-bottom-left-radius: 3px;
    border-top-left-radius: 3px;
}
.struckout{
    text-decoration: line-through;
}
.compact-toggle-dnd-1 {
    transform: scale(0.75);
    transform-origin: right;
}

.compact-toggle-dnd {
    transform: scale(0.5);
    transform-origin: right;
}



.dnd-card-height{
    max-height: 50px;
}

.dnd-drink-image-max{
    max-height: 100px;

    border-top-left-radius: 5px !important;
    border-bottom-left-radius: 5px !important;
}
.section-spread{
    justify-content: space-between;
}
.aligncenter{
    justify-content:center
}
.courseheading{
    font-size: 24px !important;
    font-weight: 600;
    text-align: center;
    border-radius: 0px !important;
    text-transform: uppercase;

}
.white-text-heading{
    color: white !important;
    font-weight: 600 !important;
    text-decoration: none;
}
.white-cog{
  color: white !important;
}
.cog-position-1{
      position: absolute;
      bottom: -9px;
      left: -1px;
    }
    </style>
